import { api } from '../index.js'
import qs from 'qs'

export async function getCustomerAppointments(
  status,
  Types,
  cities,
  hosts,
  client,
  startDate,
  endDate,
  startTime,
  endTime,
  page,
  findHostMode,
  category,
  search,
  clients,
  branches,
  confirmed,
  confirmationEmailSent
) {

  try {
    const endPointFetchType = category === 'GROUP' ? 'web/appointmentGroup/list' : 'web/appointment/list'
    const params = {
      search: search,
      status: status,
      hostsIds: hosts,
      visitTypes: Types,
      clientsIds: client ?? clients,
      citiesIds: cities,
      startDate: startDate,
      endDate: endDate,
      startTime: startTime,
      endTime: endTime,
      size: '9999',
      page: page,
      showAllDetails: 'false',
      findHostMode: findHostMode,
      branchesIds: branches,
      confirmed: confirmed,
      confirmationEmailSent: confirmationEmailSent
    }

    const { data } = await api.get(endPointFetchType, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
     })

    return data
  } catch (error) {
    console.log(error)
  }
}

export async function getCustomerAppointmentId(appointmentId) {
  const { data } = await api.get(`/web/appointment/show/${appointmentId}`)
  return data
}
